import { useDispatch } from "react-redux";
import { ORIGINAL_LANGUAGE_SIGNIFIER } from "../components/shared/TranslationDropDown";

const translateObject = (
  id: string,
  language: string,
  type: string,
  onSuccess: (data: any, language: string) => void,
) => {
  if (language === ORIGINAL_LANGUAGE_SIGNIFIER) return;

  fetch(`/translations/${language}/${type}/${id}`)
    .then((response) => response.json())
    .then((data) => {
      onSuccess(data, language);
    })
    .catch((e) => {
      console.error(e);
      toastr.error(
        I18n.t("js.activitystreams.activity.translation_controls.error"),
      );
    });
};

export function useTranslationService() {
  const dispatch = useDispatch();

  const setLastUsedLanguage = (language: string) => {
    dispatch({
      type: "currentMember/LANGUAGE/SET_LAST_USED",
      payload: language,
    });
  };

  return {
    setLastUsedLanguage,
    translateObject,
  };
}
